"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.twoFactorSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const zod_1 = require("zod");
const strings_1 = require("../../../../../../../constants/strings");
const sessionQuery_1 = require("../../../../../../../queries/sessionQuery");
const zustandStore_1 = require("../../../../../../../zustandStore");
const setupTwoFactorAuth_1 = require("../../../../activateForm/setupTwoFactorAuth");
const formWrapper_1 = __importDefault(require("../../../formWrapper"));
const useValidation_1 = require("../../../hooks/useValidation");
const formInput_1 = __importDefault(require("../../common/formInput"));
const logger = (0, pino_1.default)();
exports.twoFactorSchema = zod_1.z.object({
    authCode: zod_1.z.string().min(6, 'Authentication code must be at least 6 characters long'),
});
const SetupTwoFactorAuth = ({ style = {} }) => {
    const [showSecretKey, setShowSecretKey] = (0, react_1.useState)(false);
    const { setPageLoading, steps, setNotification, setStepsData } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const [formState, setFormState] = (0, react_1.useState)({
        authCode: '',
    });
    const { validateField, clearFieldError, fieldErrors, validateAllSchema } = (0, useValidation_1.useValidation)();
    const sendMfaCode = (0, sessionQuery_1.useSendMfaCodeQuery)();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => {
            const updatedState = { ...prev, [name]: value };
            clearFieldError(name);
            return updatedState;
        });
    };
    const handleBlur = (e) => {
        if (e) {
            const { name = '' } = e.target;
            validateField(exports.twoFactorSchema, name, formState);
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        validateAllSchema(exports.twoFactorSchema, formState);
        sendMfaCode.mutate({ code: formState.authCode, challengeName: 'SOFTWARE_TOKEN_MFA' }, {
            onSuccess: async (data) => {
                setStepsData({
                    mfaOtp: {
                        status: data.mfaOtp.status,
                        secret: data.mfaOtp.secret || '',
                        qrCode: data.mfaOtp.qrCode,
                    },
                    phoneSetup: {
                        status: data.phoneSetup.status,
                        phoneDetails: data.phoneSetup.phoneDetails,
                    },
                });
                if (data.mfaOtp.status === 'authenticated') {
                    setFormState({ authCode: '' });
                }
            },
            onError: error => {
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: setupTwoFactorAuth_1.invalidOtpCodeSentMessage,
                    },
                ]);
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(formWrapper_1.default, { style: style, formName: "Setup your Two Factor Authentication", onSubmit: handleSubmit, submitButton: {
            label: strings_1.sessionStrings.CONTINUE,
            isDisabled: !exports.twoFactorSchema.safeParse(formState).success,
        }, isFormPending: sendMfaCode.isPending, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", gutterBottom: true, children: "2FA, or two factor authentication, helps reduce the risk of unauthorized access to your account. Enable 2FA and gain peace of mind that your account is secure." }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", gutterBottom: true, children: "To start, install an authenticator application of your choice on your phone. Popular authenticator apps include Google Authenticator, Authy or Microsoft Authenticator." }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", gutterBottom: true, children: "Once installed follow the instructions to add or setup an account by scanning the QR code." }), (0, jsx_runtime_1.jsx)("div", { style: { textAlign: 'center', margin: '20px 0' }, children: (0, jsx_runtime_1.jsx)("img", { src: steps.data.mfaOtp?.qrCode || '', alt: "QR Code" }) }), (0, jsx_runtime_1.jsx)(material_1.Link, { href: "#", onClick: e => {
                    e.preventDefault();
                    setShowSecretKey(!showSecretKey);
                }, style: {
                    fontWeight: '600',
                    fontSize: '12px',
                    lineHeight: '20px',
                    alignItems: 'center',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    color: 'rgb(0, 174, 255)',
                    display: 'block',
                    margin: 'auto',
                    width: '100%',
                    textDecoration: 'none',
                }, children: showSecretKey ? 'HIDE SECRET KEY' : 'SHOW SECRET KEY' }), showSecretKey && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body1", gutterBottom: true, style: { wordBreak: 'break-word' }, children: ["Secret Key: ", steps.data.mfaOtp?.secret || 'Not Available'] })), (0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Enter a code from your authenticator app", name: "authCode", value: formState.authCode, error: fieldErrors['authCode'], onChange: handleInputChange, onBlur: handleBlur })] }));
};
exports.default = SetupTwoFactorAuth;
